import FullPageLayout from "../../../../templates/FullPageLayout";
import { Button, Col, Row, Tabs, TabsProps } from "antd";
import ClientIndividual from "./Tabs/ClientIndividual";
import ClientCompany from "./Tabs/ClientCompany";
import { useState } from "react";
import { NeedHelp } from "../../../../atoms/CustomIcons";

export default function AddSubcontractor() {
  const [loading, setLoading] = useState(false);
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Company",
      children: <ClientCompany setLoading={setLoading} companyId={companyId} />,
    },
    {
      key: "2",
      label: "Individual",
      children: (
        <ClientIndividual setLoading={setLoading} companyId={companyId} />
      ),
    },
  ];

  return (
    <FullPageLayout loading={loading}>
      <Button className="btn-sm fixedTopBtn">
        <NeedHelp /> Need help?
      </Button>

      <Row gutter={8} style={{ width: "672px" }}>
        <Col span={24}>
          <div
            className="title"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <div>
              <h2> Add subcontractor </h2>
              <p>Subs complete their services during scheduled visits.</p>
            </div>
            {/* <Button
              htmlType="button"
              className="outlined-btn btn-sm"
              type="primary"
            >
              <UploadIcon /> Bulk upload
            </Button> */}
          </div>
        </Col>

        <Col span={24}>
          <div>
            <Row gutter={20}>
              <Col span={24}>
                <div
                  style={{
                    position: "absolute",
                    zIndex: 99,
                    width: "calc(100% - 20px)",
                    left: "11px",
                    top: "0",
                    paddingLeft: "20px",
                    paddingTop: "20px",
                  }}
                >
                  <h4 style={{ marginBottom: "16px" }}> General details </h4>
                  <h5
                    style={{
                      marginBottom: "4px",
                      fontSize: "14px",
                      lineHeight: "20px",
                      fontWeight: "500",
                    }}
                  >
                    Type
                  </h5>
                </div>
                <Tabs
                  defaultActiveKey="1"
                  items={items}
                  className="clientsTabs"
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </FullPageLayout>
  );
}
